// extracted by mini-css-extract-plugin
export default {"sortableItem":"SortableMatchItem_sortableItem__XHDEw","dragging":"SortableMatchItem_dragging__Yp7l6","slideIn":"SortableMatchItem_slideIn__HC-SQ"};